export default __webpack_public_path__ + "static/media/pv_grid.0ddf3f87.png";